import { useState } from 'react';
import { removeRoom } from 'services/api';
import type { Room } from 'services/api';

interface UseRemoveServiceProps {
  onItemRemove: () => void;
  selectedRoom: Room | null;
  hide: () => void;
}

export const useRemoveService = ({ onItemRemove, selectedRoom, hide }: UseRemoveServiceProps) => {
  const [loading, setLoading] = useState(false);

  const confirm = () => {
    setLoading(true);
    removeRoom(selectedRoom!.id)
      .then(() => {
        hideModal();
        onItemRemove();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const hideModal = () => {
    hide();
  };

  return {
    state: { loading },
    methods: { hideModal, confirm },
  };
};
